export default {
  name: 'te',
  el: {
    breadcrumb: {
      label: 'బ్రెడ్‌క్రంబ్',
    },
    colorpicker: {
      confirm: 'సరే',
      clear: 'తొలగించు',
      defaultLabel: 'రంగు ఎంచుకోండి',
      description:
        'ప్రస్తుత రంగు {color}. కొత్త రంగును ఎంచుకోవడానికి ఎంటర్ నొక్కండి.',
      alphaLabel: 'అల్ఫా విలువను ఎంచుకోండి',
      alphaDescription: 'alpha {alpha}, current color is {color}', // to be translated
      hueLabel: 'pick hue value', // to be translated
      hueDescription: 'hue {hue}, current color is {color}', // to be translated
      svLabel: 'pick saturation and brightness value', // to be translated
      svDescription:
        'saturation {saturation}, brightness {brightness}, current color is {color}', // to be translated
      predefineDescription: 'select {value} as the color', // to be translated
    },
    datepicker: {
      now: 'ఇప్పుడు',
      today: 'ఈ రోజు',
      cancel: 'రద్దు',
      clear: 'తొలగించు',
      confirm: 'సరే',
      dateTablePrompt:
        'నెలలోని రోజును ఎంచుకోవడానికి ఈతలు మరియు ఎంటర్ ఉపయోగించండి',
      monthTablePrompt: 'నెలను ఎంచుకోవడానికి ఈతలు మరియు ఎంటర్ ఉపయోగించండి',
      yearTablePrompt:
        'సంవత్సరాన్ని ఎంచుకోవడానికి ఈతలు మరియు ఎంటర్ ఉపయోగించండి',
      selectedDate: 'ఎంచుకున్న తేదీ',
      selectDate: 'తేదీ ఎంచుకోండి',
      selectTime: 'సమయం ఎంచుకోండి',
      startDate: 'ప్రారంభ తేదీ',
      startTime: 'ప్రారంభ సమయం',
      endDate: 'ముగింపు తేదీ',
      endTime: 'ముగింపు సమయం',
      prevYear: 'గత సంవత్సరం',
      nextYear: 'తదుపరి సంవత్సరం',
      prevMonth: 'గత నెల',
      nextMonth: 'తదుపరి నెల',
      year: 'సంవత్సరం',
      month1: 'జనవరి',
      month2: 'ఫిబ్రవరి',
      month3: 'మార్చి',
      month4: 'ఏప్రిల్',
      month5: 'మే',
      month6: 'జూన్',
      month7: 'జూలై',
      month8: 'ఆగస్టు',
      month9: 'సెప్టెంబర్',
      month10: 'అక్టోబర్',
      month11: 'నవంబర్',
      month12: 'డిసెంబర్',
      weeks: {
        sun: 'ఆది',
        mon: 'సోమ',
        tue: 'మంగళ',
        wed: 'బుధ',
        thu: 'గురు',
        fri: 'శుక్ర',
        sat: 'శని',
      },
      weeksFull: {
        sun: 'ఆదివారం',
        mon: 'సోమవారం',
        tue: 'మంగళవారం',
        wed: 'బుధవారం',
        thu: 'గురువారం',
        fri: 'శుక్రవారం',
        sat: 'శనివారం',
      },
      months: {
        jan: 'జన',
        feb: 'ఫిబ్ర',
        mar: 'మార్చి',
        apr: 'ఏప్రి',
        may: 'మే',
        jun: 'జూన్',
        jul: 'జూలై',
        aug: 'ఆగ',
        sep: 'సెప్',
        oct: 'అక్టో',
        nov: 'నవం',
        dec: 'డిసెం',
      },
    },
    inputNumber: {
      decrease: 'సంఖ్య తగ్గించు',
      increase: 'సంఖ్య పెంచు',
    },
    select: {
      loading: 'లోడ్ అవుతోంది',
      noMatch: 'ఫలితాలు కనబడలేదు',
      noData: 'డేటా లేదు',
      placeholder: 'ఎంచుకోండి',
    },
    mention: {
      loading: 'లోడ్ అవుతోంది',
    },
    dropdown: {
      toggleDropdown: 'డ్రాప్‌డౌన్ మార్చు',
    },
    cascader: {
      noMatch: 'ఫలితాలు కనబడలేదు',
      loading: 'లోడ్ అవుతోంది',
      placeholder: 'ఎంచుకోండి',
      noData: 'డేటా లేదు',
    },
    pagination: {
      goto: 'వెళ్ళండి',
      pagesize: '/పేజీ',
      total: 'మొత్తం {total}',
      pageClassifier: '',
      page: 'పేజీ',
      prev: 'మునుపటి పేజీకి వెళ్ళండి',
      next: 'తదుపరి పేజీకి వెళ్ళండి',
      currentPage: 'పేజీ {pager}',
      prevPages: 'మునుపటి {pager} పేజీలు',
      nextPages: 'తదుపరి {pager} పేజీలు',
      deprecationWarning:
        'పాత పద్ధతులు గుర్తించబడ్డాయి, మరిన్ని వివరాల కోసం el-pagination డాక్యుమెంటేషన్ చూడండి',
    },
    dialog: {
      close: 'ఈ డైలాగ్ మూసివేయి',
    },
    drawer: {
      close: 'ఈ డైలాగ్ మూసివేయి',
    },
    messagebox: {
      title: 'సందేశం',
      confirm: 'సరే',
      cancel: 'రద్దు',
      error: 'చెల్లని ఇన్‌పుట్',
      close: 'ఈ డైలాగ్ మూసివేయి',
    },
    upload: {
      deleteTip: 'తొలగించడానికి డిలీట్ నొక్కండి',
      delete: 'తొలగించు',
      preview: 'ప్రివ్యూ',
      continue: 'కొనసాగించు',
    },
    slider: {
      defaultLabel: '{min} మరియు {max} మధ్య స్లైడర్',
      defaultRangeStartLabel: 'ప్రారంభ విలువ ఎంచుకోండి',
      defaultRangeEndLabel: 'ముగింపు విలువ ఎంచుకోండి',
    },
    table: {
      emptyText: 'డేటా లేదు',
      confirmFilter: 'నిర్ధారించు',
      resetFilter: 'రీసెట్',
      clearFilter: 'తొలగించు',
      sumText: 'మొత్తం',
      selectAllLabel: 'Select all rows', // to be translated
      selectRowLabel: 'Select this row', // to be translated
      expandRowLabel: 'Expand this row', // to be translated
      collapseRowLabel: 'Collapse this row', // to be translated
      sortLabel: 'Sort by {column}', // to be translated
      filterLabel: 'Filter by {column}', // to be translated
    },
    tag: {
      close: 'Close this tag', // to be translated
    },
    tour: {
      next: 'తదుపరి',
      previous: 'గత',
      finish: 'ముగించు',
      close: 'Close this dialog', // to be translated
    },
    tree: {
      emptyText: 'డేటా లేదు',
    },
    transfer: {
      noMatch: 'ఫలితాలు కనబడలేదు',
      noData: 'డేటా లేదు',
      titles: ['జాబితా 1', 'జాబితా 2'],
      filterPlaceholder: 'కీవర్డ్ నమోదు చేయండి',
      noCheckedFormat: '{total} అంశాలు',
      hasCheckedFormat: '{checked}/{total} ఎంపిక చేయబడ్డాయి',
    },
    image: {
      error: 'విఫలమైంది',
    },
    pageHeader: {
      title: 'వెనక్కి',
    },
    popconfirm: {
      confirmButtonText: 'అవును',
      cancelButtonText: 'కాదు',
    },
    carousel: {
      leftArrow: 'క్యారసెల్ ఎడమ బాణం',
      rightArrow: 'క్యారసెల్ కుడి బాణం',
      indicator: 'క్యారసెల్ సూచిక {index} కి మార్చు',
    },
  },
}
